import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {SalesByCategoryReportModel} from "./sales-by-category-report-model.service";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-sales-by-category-report",
    templateUrl: "./sales-by-category-report.component.html",
    providers: [provideReportModel(SalesByCategoryReportModel)]
})
export class SalesByCategoryReportComponent extends AbstractReportPage {

    constructor(public model: SalesByCategoryReportModel) {
        super();
    }
}
